import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { useParams } from 'react-router-dom'
import IRestaurantInfo from 'models/IRestaurantInfo'
import IProduct from 'models/IProduct'
import { CartItem } from 'models/IDeliveryOrder'
import { CustomerCart } from 'models/IDeliveryOrder'

export interface CartProps {}

export const useCart = (props: CartProps) => {
  const { restaurantName } = useParams<{
    restaurantName: string
  }>()

  const [currency, setCurrency] = useState<string>('')
  const [customerCart, setCustomerCart] = useState<CustomerCart[]>([])

  const restaurantInfo: IRestaurantInfo | null = useSelector(
    (state: RootState) => state.restaurantInfo.restaurantInfo
  )
  const cartItems: CartItem[] | null = useSelector(
    (state: RootState) => state.orders.cart
  )
  const products: IProduct[] | null = useSelector(
    (state: RootState) => state.products.products
  )

  const updateCustomerCart = () => {
    if (products && products.length && cartItems) {
      const cartWithDetails: CustomerCart[] = cartItems.map((cartItem) => {
        const product = products.find((p) => p.id === cartItem.productId)

        let finalPrice = 0

        if (product) {
          if (product.price !== null && product.price !== undefined) {
            finalPrice = Number(product.price)
          } else if (product.priceList && product.priceList.length > 0) {
            const variant = product.priceList.find(
              (v) => v.name === cartItem.variantName
            )

            if (variant) {
              finalPrice = Number(variant.price)
            } else {
              finalPrice = Number(product.priceList[0].price)
            }
          }
        }

        return {
          ...cartItem,
          productName: product ? product.name : 'Unknown Product',
          price: finalPrice,
        }
      })

      setCustomerCart(cartWithDetails)
    }
  }

  useEffect(() => {
    try {
      if (restaurantInfo) {
        setCurrency(restaurantInfo.currency)
      }
      updateCustomerCart()
    } catch (error) {
      console.error(error)
    }
  }, [])

  useEffect(() => {
    updateCustomerCart()
  }, [cartItems, products])

  return {
    ...props,
    restaurantName,
    customerCart,
    products,
    currency,
  }
}
